import React from 'react';
import SectionHeading from '../components/SectionHeading';
import CTAButton from '../components/CTAButton';
import { CheckCircle, ArrowRight } from 'lucide-react';
const ProgramsPage = () => {
  return <div className="w-full" data-id="element-1472">
      {/* Hero Section */}
      <section className="bg-navy text-white py-16" data-id="element-1473">
        <div className="container-custom text-center" data-id="element-1474">
          <h1 className="text-4xl md:text-5xl font-bold font-montserrat mb-6" data-id="element-1475">
            Our Programs
          </h1>
          <p className="text-xl max-w-3xl mx-auto" data-id="element-1476">
            Comprehensive solutions to help you build and scale your business to
            $1M+ annual revenue.
          </p>
        </div>
      </section>
      {/* Programs Overview */}
      <section className="section-padding" data-id="element-1477">
        <div className="container-custom" data-id="element-1478">
          <SectionHeading title="The Operation Launchpad Advantage" subtitle="Our incubator program provides everything you need to build a successful business without the decade-long learning curve." data-id="element-1479" />
          <div className="bg-white rounded-lg shadow-lg p-8 mb-16" data-id="element-1480">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-1481">
              <div data-id="element-1482">
                <h3 className="text-2xl font-bold text-navy mb-6 font-montserrat" data-id="element-1483">
                  Our Unique Approach
                </h3>
                <p className="mb-4" data-id="element-1484">
                  Unlike traditional business programs that charge high upfront
                  fees, Operation Launchpad takes a different approach. We offer
                  our comprehensive suite of business solutions at discounted or
                  no upfront cost.
                </p>
                <p className="mb-4" data-id="element-1485">
                  Instead, we take a vested interest in your success through
                  future billing once your business is generating revenue. This
                  ensures that we're truly invested in your growth - we only win
                  when you win.
                </p>
                <p data-id="element-1486">
                  This model allows us to work with promising entrepreneurs who
                  have the drive and commitment but might lack the initial
                  capital to invest in business development.
                </p>
              </div>
              <div data-id="element-1487">
                <img src="https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" alt="Mentor working with entrepreneur" className="rounded-lg shadow-md w-full h-auto" data-id="element-1488" />
              </div>
            </div>
          </div>
          {/* Veterans Program Section */}
          <div className="mb-16 bg-lightGray rounded-lg p-8" data-id="element-1489">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1490">
              <div data-id="element-1491">
                <h3 className="text-2xl font-bold text-navy mb-6 font-montserrat" data-id="element-1492">
                  Veterans Business Launchpad
                </h3>
                <p className="mb-4" data-id="element-1493">
                  Operation Launchpad proudly supports military veterans and
                  active service members preparing for discharge with a
                  specialized program designed to leverage their unique skills
                  and experiences in the business world.
                </p>
                <p className="mb-4" data-id="element-1494">
                  Our Veterans Business Launchpad program recognizes that
                  military service develops exceptional leadership, discipline,
                  and problem-solving abilities—qualities that form the
                  foundation of successful entrepreneurship.
                </p>
                <p className="mb-4" data-id="element-1495">
                  We provide tailored mentorship, resources, and support systems
                  specifically designed to help veterans navigate the transition
                  from military service to business ownership.
                </p>
                <div className="mt-6" data-id="element-1496">
                  <h4 className="font-bold text-navy mb-4" data-id="element-1497">
                    Program Benefits for Veterans:
                  </h4>
                  <ul className="space-y-3" data-id="element-1498">
                    {['Specialized training addressing the unique challenges of military-to-civilian transition', 'Mentorship from successful veteran entrepreneurs who understand your journey', 'Access to veteran-specific funding resources and opportunities', 'Guidance on translating military skills to business applications', 'Community of fellow veteran entrepreneurs for support and networking', 'Assistance with VA programs and benefits related to business ownership'].map((benefit, index) => <li key={index} className="flex items-start" data-id="element-1499">
                        <CheckCircle className="text-gold mr-2 flex-shrink-0 mt-1" size={18} data-id="element-1500" />
                        <span data-id="element-1501">{benefit}</span>
                      </li>)}
                  </ul>
                </div>
                <div className="mt-6" data-id="element-1502">
                  <a href="/apply" className="btn-primary inline-block" data-id="element-1503">
                    Apply to Veterans Program
                  </a>
                </div>
              </div>
              <div data-id="element-1504">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jJStBdptK8ddFxenDwjw5Q/military-to-entrepreneur.png" alt="Veteran entrepreneur working on business plan" className="rounded-lg shadow-md w-full h-auto" data-id="element-1505" />
              </div>
            </div>
          </div>
          <div className="mb-16" data-id="element-1506">
            <h3 className="text-2xl font-bold text-navy mb-8 font-montserrat text-center" data-id="element-1507">
              Our Comprehensive Solutions
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1508">
              <ProgramCard title="AETLAS Solutions" description="Advanced business systems and technology to streamline operations, improve efficiency, and scale your business." features={['CRM and lead management', 'Project management tools', 'Digital marketing and automation', 'Financial tracking and reporting', 'Client communication systems']} data-id="element-1509" />
              <ProgramCard title="Business Academy" description="Training and resources to develop your skills as a business owner and industry leader." features={['Business strategy development', 'Sales and marketing training', 'Financial management education', 'Leadership development', 'Industry-specific knowledge']} data-id="element-1510" />
              <ProgramCard title="Entrepreneur Boardroom" description="Exclusive mastermind community and mentorship to connect with successful entrepreneurs and industry experts." features={['Peer networking opportunities', 'Expert mentorship sessions', 'Accountability partnerships', 'Resource sharing', 'Collaborative problem-solving']} data-id="element-1511" />
            </div>
          </div>
          <div className="bg-lightGray rounded-lg p-8" data-id="element-1512">
            <h3 className="text-2xl font-bold text-navy mb-6 font-montserrat text-center" data-id="element-1513">
              Program Timeline
            </h3>
            <div className="space-y-8" data-id="element-1514">
              <TimelineStep number="1" title="Application & Assessment" description="Submit your application and complete our assessment process to determine if you're a good fit for our program." data-id="element-1515" />
              <TimelineStep number="2" title="Onboarding & Strategy Development" description="Work with our team to develop a customized growth strategy for your business." data-id="element-1516" />
              <TimelineStep number="3" title="Systems Implementation" description="We'll help you implement the necessary business systems and technologies to streamline your operations." data-id="element-1517" />
              <TimelineStep number="4" title="Ongoing Mentorship & Support" description="Receive continuous guidance, training, and support as you grow your business toward $1M+ in annual revenue." data-id="element-1518" />
              <TimelineStep number="5" title="Scaling & Optimization" description="Fine-tune your business model and operations to maximize profitability and prepare for continued growth." data-id="element-1519" />
            </div>
          </div>
        </div>
      </section>
      {/* Eligibility Section */}
      <section className="section-padding bg-navy text-white" data-id="element-1520">
        <div className="container-custom" data-id="element-1521">
          <SectionHeading title="Who Can Apply" subtitle="Our program is designed for individuals who meet the following criteria:" className="text-white" data-id="element-1522" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-1523">
            <div className="bg-white/10 rounded-lg p-8" data-id="element-1524">
              <h3 className="text-2xl font-bold text-gold mb-6 font-montserrat" data-id="element-1525">
                Ideal Candidates
              </h3>
              <ul className="space-y-4" data-id="element-1526">
                {['Aspiring entrepreneurs with a clear business vision', 'Existing small business owners looking to scale', 'Military veterans and service members transitioning to civilian life', 'Individuals with a strong work ethic and commitment to growth', 'Those willing to follow proven systems and processes', 'People who value mentorship and community support', 'Determined individuals ready to build something meaningful'].map((item, index) => <li key={index} className="flex items-start" data-id="element-1527">
                    <CheckCircle className="text-gold mr-3 flex-shrink-0 mt-1" size={20} data-id="element-1528" />
                    <span data-id="element-1529">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div className="bg-white/10 rounded-lg p-8" data-id="element-1530">
              <h3 className="text-2xl font-bold text-gold mb-6 font-montserrat" data-id="element-1531">
                What We Look For
              </h3>
              <p className="mb-6" data-id="element-1532">
                Success in our program isn't determined by your background or
                education, but by your character and commitment. We look for
                individuals who demonstrate:
              </p>
              <ul className="space-y-4" data-id="element-1533">
                {['Dedication to hard work and personal growth', 'Resilience and ability to overcome challenges', 'Coachability and willingness to learn', 'Integrity and strong ethical standards', 'Clear vision for their business future', 'Commitment to serving clients with excellence'].map((item, index) => <li key={index} className="flex items-start" data-id="element-1534">
                    <CheckCircle className="text-gold mr-3 flex-shrink-0 mt-1" size={20} data-id="element-1535" />
                    <span data-id="element-1536">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="section-padding bg-lightGray" data-id="element-1537">
        <div className="container-custom text-center" data-id="element-1538">
          <h2 className="text-3xl md:text-4xl font-bold font-montserrat text-navy mb-6" data-id="element-1539">
            Ready to Transform Your Business?
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto text-darkGray" data-id="element-1540">
            Apply today to see if Operation Launchpad is the right partner for
            your entrepreneurial journey.
          </p>
          <CTAButton text="Apply Now" to="/apply" className="text-lg" data-id="element-1541" />
        </div>
      </section>
    </div>;
};
const ProgramCard = ({
  title,
  description,
  features
}) => {
  return <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200 h-full flex flex-col" data-id="element-1542">
      <div className="bg-navy p-6" data-id="element-1543">
        <h3 className="text-xl font-bold text-white mb-2 font-montserrat" data-id="element-1544">
          {title}
        </h3>
        <p className="text-gray-300" data-id="element-1545">{description}</p>
      </div>
      <div className="p-6 flex-grow" data-id="element-1546">
        <h4 className="font-bold text-navy mb-4 font-montserrat" data-id="element-1547">
          Key Features:
        </h4>
        <ul className="space-y-3" data-id="element-1548">
          {features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-1549">
              <CheckCircle className="text-gold mr-2 flex-shrink-0 mt-1" size={18} data-id="element-1550" />
              <span data-id="element-1551">{feature}</span>
            </li>)}
        </ul>
      </div>
      <div className="p-6 pt-0" data-id="element-1552">
        <a href="/apply" className="inline-flex items-center text-navy font-bold hover:text-orange transition duration-300" data-id="element-1553">
          Learn More
          <ArrowRight size={18} className="ml-2" data-id="element-1554" />
        </a>
      </div>
    </div>;
};
const TimelineStep = ({
  number,
  title,
  description
}) => {
  return <div className="flex" data-id="element-1555">
      <div className="mr-6" data-id="element-1556">
        <div className="bg-navy text-white w-12 h-12 rounded-full flex items-center justify-center text-xl font-bold" data-id="element-1557">
          {number}
        </div>
      </div>
      <div data-id="element-1558">
        <h4 className="text-xl font-bold text-navy mb-2 font-montserrat" data-id="element-1559">
          {title}
        </h4>
        <p className="text-darkGray" data-id="element-1560">{description}</p>
      </div>
    </div>;
};
export default ProgramsPage;